import React from 'react';
import '/Users/jilin/projects/antd/rc-dialog/docs/demo/multiple-Portal.md?watch=parent';
import * as docs_demo_multiple_portal_demo_multiple_portal_deps_1 from 'react';
import * as docs_demo_multiple_portal_demo_multiple_portal_deps_2 from 'rc-drawer';
import * as docs_demo_multiple_portal_demo_multiple_portal_deps_3 from 'rc-drawer/assets/index.css';
import * as docs_demo_multiple_portal_demo_multiple_portal_deps_4 from 'rc-dialog';
import * as docs_demo_multiple_portal_demo_multiple_portal_deps_5 from '/Users/jilin/projects/antd/rc-dialog/assets/index.less';
export const demos = {
  'docs-demo-multiple-portal-demo-multiple-portal': {
    component: React.memo(React.lazy(() => import( /* webpackChunkName: "demos" */ '/Users/jilin/projects/antd/rc-dialog/docs/examples/multiple-Portal.tsx?techStack=react'))),
    asset: {
  "type": "BLOCK",
  "id": "docs-demo-multiple-portal-demo-multiple-portal",
  "refAtomIds": [],
  "dependencies": {
    "index.tsx": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/docs/examples/multiple-Portal.tsx?dumi-raw').default
    },
    "react": {
      "type": "NPM",
      "value": "18.3.1"
    },
    "rc-drawer": {
      "type": "NPM",
      "value": "7.2.0"
    },
    "@rc-component/dialog": {
      "type": "NPM",
      "value": "1.0.1"
    },
    "../../assets/index.less": {
      "type": "FILE",
      "value": require('/Users/jilin/projects/antd/rc-dialog/assets/index.less?dumi-raw').default
    }
  },
  "entry": "index.tsx"
},
    context: {
  "../../assets/index.less": docs_demo_multiple_portal_demo_multiple_portal_deps_5,
  "react": docs_demo_multiple_portal_demo_multiple_portal_deps_1,
  "rc-drawer": docs_demo_multiple_portal_demo_multiple_portal_deps_2,
  "rc-drawer/assets/index.css": docs_demo_multiple_portal_demo_multiple_portal_deps_3,
  "rc-dialog": docs_demo_multiple_portal_demo_multiple_portal_deps_4,
  "/Users/jilin/projects/antd/rc-dialog/assets/index.less": docs_demo_multiple_portal_demo_multiple_portal_deps_5
},
    renderOpts: {
          
          compile: async (...args) => {
            return (await import('/Users/jilin/projects/antd/rc-dialog/node_modules/_dumi@2.4.17@dumi/dist/client/misc/reactDemoCompiler.js')).default(...args);
          },
        },
  },
};